import * as todos from "./todos";
import * as visibilityFilter from "./visibilityFilter";
import * as antDemo from "./antDemo";
import * as share from "./share";
// 地理信息的redux管理模块
import * as region from "./service/region";
// 订单来源
import * as orderSource from "./service/orderSource";
// 贸易状态
import * as tradingStatus from "./service/tradingStatus";
// 选择器数据源
import * as selectorSource from "./service/selectorSource";
// 订单信息管理
import * as orderInfo from "./service/orderInfo";
// 订单详情管理
import * as orderDetails from "./service/orderDetails";
// 系统信息管理 包括系统菜单
import * as sysInfo from "./service/sysInfo";
// 订单状态管理
import * as orderStatus from "./service/orderStatus";
// 订单标签管理
import * as orderTag from "./service/orderTag";
// 扩展功能管理
import * as extFunc from "./extFunc";
// 快捷键管理
import * as hotkey from "./hotkey";
// 全局状态管理
import * as globalStatus from "./globalStatus";
// 用户信息管理
import * as userInfo from "./service/userInfo";
// autoComplete管理
import * as autoComplete from "./autoComplete";
// 消息管理
import * as noticeMg from "./noticeMg";
// 上传管理
import * as uploadMg from "./uploadMg";

import * as dashboard from './dashboard'

import * as customOrderList from './service/customOrderList'

import * as customOrder from './service/customOrder'
import * as fileExport from "./fileExport";

// 多model集合导出
export default {
  todos: todos.todos,
  visibilityFilter: visibilityFilter.visibilityFilter,
  antDemo: antDemo.antDemo,
  share: share.share,
  region: region.region,
  orderSource: orderSource.orderSource,
  tradingStatus: tradingStatus.tradingStatus,
  selectorSource: selectorSource.selectorSource,
  orderInfo: orderInfo.orderInfo,
  orderDetails: orderDetails.orderDetails,
  sysInfo: sysInfo.sysInfo,
  extFunc: extFunc.extFunc,
  hotkey: hotkey.hotkey,
  globalStatus: globalStatus.globalStatus,
  orderStatus: orderStatus.orderStatus,
  orderTag: orderTag.orderTag,
  userInfo: userInfo.userInfo,
  autoComplete: autoComplete.autoComplete,
  noticeMg: noticeMg.noticeMg,
  uploadMg: uploadMg.uploadMg,
  dashboard: dashboard.dashboard,
  customOrderList: customOrderList.customOrderList,
  customOrder: customOrder.customOrder,
  fileExport: fileExport.fileExport,
};
